// this function is not working in prod build,
// as proptypes are removed whild prod build
export default function splitComponentProps(props: any, Component: any) {
  const componentPropTypes = Component.propTypes;

  if (!Array.isArray(componentPropTypes)) {
    // console.log(Object.keys(componentPropTypes));
  }

  const parentProps = {};
  const childProps = {};

  Object.entries(props).forEach(([propName, propValue]) => {
    if (Array.isArray(componentPropTypes) && componentPropTypes.includes(propName)) {
      parentProps[propName] = propValue;
    } else if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}
